<template>
  <div class="card mt-4">
    <div class="table-responsive">
      <div class="table-controls m-3 d-flex">
        <div class="controls-wrap d-flex align-items-center">
          <!-- Integration Field -->
          <Search class="mr-3" placeholderText="Search (name)" @search="doSearch" />

          <div
            v-show="!isPreviouslySubmited"
            class="published ms-auto text-center"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Include previously reviewed applications"
            @click="
              isPreviouslySubmited = !isPreviouslySubmited;
              toggle($event);
            "
          >
            <span class="fa-stack">
              <i
                style="font-size:21px;"
                class="fas fa-dove"
                :class="isPreviouslySubmited ? 'is-clicked' : ''"
              ></i>
            </span>
          </div>

          <div
            class="published ms-auto text-center"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Exclude previously reviewed applications"
            @click="
              isPreviouslySubmited = !isPreviouslySubmited;
              toggle($event);
            "
            v-show="isPreviouslySubmited"
          >
            <span class="fa-stack">
              <i
                style="font-size:21px;"
                class="fas fa-dove"
                :class="isPreviouslySubmited ? 'is-clicked' : ''"
              ></i>
            </span>
          </div>
        </div>
      </div>

      <table class="table table-striped custom-table desktop-only-table">
        <thead class="bg-dark">
          <tr>
            <th nowrap scope="col">Name</th>
            <th nowrap scope="col">Location</th>
            <th nowrap scope="col">Documents</th>
            <th nowrap scope="col">Signed</th>
            <th nowrap scope="col" style="width: 5%; text-align: center">&nbsp;</th>
            <th nowrap scope="col" style="width: 5%; text-align: center">&nbsp;</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="freelancer in freelancers.data" :key="freelancer.candidate_id">
            <td id="title" nowrap>
              <router-link
                :to="{ name: 'candidate_id', params: { candidate_id: freelancer.candidate_id } }"
              >
                {{ freelancer.candidate }}
              </router-link>
            </td>
            <td v-if="freelancer.country && freelancer.city">
              {{ freelancer.country.name }}, {{ freelancer.city.name }}
            </td>
            <td>
              <popper
                trigger="hover"
                :options="{
                  placement: 'top',
                  modifiers: { offset: { offset: '0,10px' } },
                }"
              >
                <div class="popper">{{ freelancer.fn_agreement }}</div>
                <a slot="reference">
                  <div>
                    <i
                      style="color:red; font-size: 22px; cursor: pointer;"
                      @click="onOpenDocPreview(freelancer.fn_agreement_id)"
                      class="fas fa-file-pdf"
                    ></i>
                  </div>
                </a>
              </popper>
            </td>
            <td>
              {{
                freelancer.signing_date
                  | formatDate({
                    format: getUserProfile.format_date,
                    timezone: getUserProfile.timezone,
                    hasHourAndMinutes: false,
                  })
              }}
            </td>
            <td>
              <popper
                v-if="freelancer.decline_message"
                trigger="hover"
                :options="{
                  placement: 'left',
                  modifiers: { offset: { offset: '0,10px' } },
                }"
              >
                <div class="popper">{{ freelancer.decline_message }}</div>
                <a slot="reference">
                  <i class="far fa-comment-dots mr-2 mt-1" style="font-size: 18px;"></i>
                </a>
              </popper>
            </td>

            <td id="actions" align="center">
              <div class="icon-wrapper d-flex justify-content-around">
                <div
                  data-toggle="modal"
                  :data-target="
                    freelancer.status !== 4 && freelancer.status !== 5 ? '.bd-like-btn' : ''
                  "
                  @click="setFreelancer(freelancer)"
                >
                  <svgHelper
                    class="approve-btn mr-2"
                    style="fill: #28a745; cursor:pointer"
                    :name="freelancer.status === 4 ? 'thumbsUpFill' : 'thumbsUp'"
                  />
                </div>
                <div
                  data-toggle="modal"
                  :data-target="
                    freelancer.status !== 4 && freelancer.status !== 5 ? '.bd-dislike-btn' : ''
                  "
                  @click="setFreelancer(freelancer)"
                >
                  <svgHelper
                    style="fill: #f02800; cursor:pointer"
                    :name="freelancer.status === 5 ? 'thumbsDownFill' : 'thumbsDown'"
                  />
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <ErrorList v-show="freelancers.length === 0" class="no-data-message" name="noReviewJobs" />
    </div>

    <Spinner :isLoading="isLoading" />

    <div class="d-flex ml-auto mt-auto bottom-controls">
      <div class="d-none d-sm-block" id="pagination">
        <!-- Pagination -->

        <Pagination
          :currentPage="currentPage"
          :totalPages="totalPages"
          @nextPage="nextPage"
          @prevPage="previousPage"
          @selectPageByNumber="setPageByNumber"
          @firstPage="setToFirstPage"
          @lastPage="setToLastPage"
          @keyup="keymonitor"
        />
      </div>
    </div>

    <!-- Modals -->

    <div
      class="modal fade bd-like-btn"
      tabindex="-1"
      role="dialog"
      aria-labelledby="mainModalLabel"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">Approve Application</div>
          <div class="modal-body">
            <p>
              Please confirm that you want to approve the application by
              <strong>{{ setForEdit.candidate }}</strong> for the Freelancing Network.
            </p>
          </div>
          <div class="modal-footer d-flex justify-content-center">
            <button
              @click="updateStatus(setForEdit.freelancing_network_id, 4)"
              type="button"
              class="btn btn-primary btn-custom"
            >
              Approve
            </button>
            <button
              type="button"
              class="btn btn-secondary btn-custom"
              data-dismiss="modal"
              ref="closeApproveModal"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade bd-dislike-btn"
      tabindex="-1"
      role="dialog"
      aria-labelledby="mainModalLabel"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">Decline Application</div>
          <div class="modal-body">
            <p>
              Please confirm that you want to decline the application by
              <strong>{{ setForEdit.candidate }}</strong> for the Freelancing Network.
            </p>
            <textarea
              class="form-control mt-2"
              v-model="msgToCandidate"
              placeholder="Message to candidate"
            ></textarea>
          </div>
          <div class="modal-footer d-flex justify-content-center">
            <button
              @click="updateStatus(setForEdit.freelancing_network_id, 5)"
              ref="rejectJobCancel"
              type="button"
              class="btn btn-primary"
            >
              Decline
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
              ref="closeRejectModal"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- End Modals -->
  </div>
</template>

<script>
import { displayResultsBasedOnScreenHeightMixin } from '../../../mixins/displayResultsBasedOnScreenHeightMixin';
import { mapActions, mapGetters } from 'vuex';
import Pagination from '@/components/Navigations/Pagination';
import CustomMainModal from '@/components/Modals/CustomMainModal';
import AddJobBtnModal from '@/components/Admin/Jobs/AddJobBtnModal';

import Search from '../../common/Search/Search';
import { employmentMixin } from '../../../mixins/employmentMixin';
import { serviceLevelMixin } from '../../../mixins/serviceLevelMixin';
import { jobStatusMixin } from '../../../mixins/jobStatusMixin';
import { stagesMixin } from '../../../mixins/stagesMixin';
import { statusMixin } from '../../../mixins/statusMixin';
import titleMixin from '../../../mixins/titleMixin';
import ErrorList from '@/components/common/errorsList';
import axios from 'axios';

export default {
  components: {
    Pagination,
    CustomMainModal,
    AddJobBtnModal,
    Search,
    ErrorList,
  },
  mixins: [
    titleMixin,
    displayResultsBasedOnScreenHeightMixin,
    employmentMixin,
    serviceLevelMixin,
    jobStatusMixin,
    statusMixin,
    stagesMixin,
  ],
  title() {
    return 'Review freelancers | Jobshark';
  },
  data: () => ({
    setForEdit: {},
    totalPages: '',
    freelancers: [],
    selectedJobForApproval: {},
    selectedJobForRejection: {},
    isPreviouslySubmited: false,
    isLoading: false,
    listOfSelectedEmployers: [],
    employersSelectOptions: [],
    showModal: false,
    searchText: '',
    pageCount: 10,
    currentPage: 1,
    msgToCandidate: '',
  }),
  methods: {
    ...mapActions([
      'retrieveEmployersDropdown',
      'retrieveReviewJobs',
      'approveReviewJob',
      'rejectReviewJob',
      'retrieveFreelancerDocumentPreviewAdmin',
    ]),

    onOpenDocPreview(docId) {
      this.retrieveFreelancerDocumentPreviewAdmin({ uuid: docId }).then(response => {
        const blob = new window.Blob([response.data], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(blob);
        window.open(fileURL);
      });
    },
    setFreelancer(freelancer) {
      this.setForEdit = freelancer;
    },
    updateStatus(id, status) {
      if (status === 5) {
        if (this.msgToCandidate.length !== 0) {
          axios
            .post(
              `${process.env.VUE_APP_API_URL}/admin/freelancer/updatestatus`,
              {
                candidate_fn_id: id,
                status: status,
                decline_message: this.msgToCandidate,
              },
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem(
                    `${process.env.VUE_APP_TOKEN_PREFIX}token`,
                  )}`,
                },
              },
            )
            .then(() => {
              this.handleSearchFiltersCurrentPage();
            })
            .catch(err => {});
        } else {
          this.$toasted.error('Please add message to candidate.', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        }
      }
      if (status === 4) {
        axios
          .post(
            `${process.env.VUE_APP_API_URL}/admin/freelancer/updatestatus`,
            {
              candidate_fn_id: id,
              status: status,
              decline_message: this.msgToCandidate,
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem(
                  `${process.env.VUE_APP_TOKEN_PREFIX}token`,
                )}`,
              },
            },
          )
          .then(() => {
            this.handleSearchFiltersCurrentPage();
          })
          .catch(err => {});
      }
    },

    toggle() {
      this.currentPage = 1;
      this.handleSearchFilters();
    },
    onCloseAddJobModal() {
      this.showModal = false;
    },
    doSearch(searchedText) {
      this.searchText = searchedText;

      this.currentPage = 1;
      this.handleSearchFilters();
    },
    getLocation(country, city) {
      if (city.name && country.name) {
        return `${city.name}, ${country.name}`;
      }
      return null;
    },
    handleSearchFilters() {
      this.isLoading = true;
      axios
        .post(
          `${process.env.VUE_APP_API_URL}/admin/freelancer/get`,
          {
            search_word: this.searchText,
            exclude_previously_reviewed: this.isPreviouslySubmited,
            page: this.currentPage,
            count: this.pageCount,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
            },
          },
        )
        .then(res => {
          this.freelancers = res.data;
          this.totalPages = res.data.last_page;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },

    handleSearchFiltersCurrentPage() {
      axios
        .post(
          `${process.env.VUE_APP_API_URL}/admin/freelancer/get`,
          {
            search_word: this.searchText,
            exclude_previously_reviewed: this.isPreviouslySubmited,
            page: Number(this.currentPage),
            count: this.pageCount,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
            },
          },
        )
        .then(res => {
          this.freelancers = res.data;
          this.totalPages = res.data.last_page;
          this.isLoading = false;
          this.setForEdit = {};
          this.$refs.closeApproveModal.click();
          this.$refs.closeRejectModal.click();
        })
        .catch(() => {
          this.isLoading = false;
        });
    },

    keymonitor(event) {
      // who caused it? "event.target.id"
      // console.log('keyup from id: ' + event.target.id);

      // what was pressed?
      let keyMessage = event.key || String.fromCharCode(event.keyCode);

      /* if (event.shiftKey) {
        keyMessage += 'Shift+';
      } */

      if (keyMessage == 'ArrowRight') {
        // this.nextPage();
      }

      if (keyMessage == 'ArrowLeft') {
        // this.previousPage();
      }
    },
    nextPage() {
      if (this.currentPage >= 1) {
        this.isLoading = true;
        this.currentPage++;
        this.handleSearchFilters();
      }
    },
    previousPage() {
      if (this.currentPage > 1) {
        this.isLoading = true;
        --this.currentPage;

        this.handleSearchFilters();
      } else {
        this.currentPage = 1;
      }
    },
    setPageByNumber(pageNumber) {
      if (pageNumber > this.totalPages || pageNumber < 1) return;
      this.isLoading = true;
      this.currentPage = pageNumber;

      this.handleSearchFilters();
    },
    setToFirstPage() {
      this.isLoading = true;
      this.currentPage = 1;

      this.handleSearchFilters();
    },
    setToLastPage(lastPage) {
      this.isLoading = true;
      this.currentPage = lastPage;

      this.handleSearchFilters();
    },
  },
  computed: {
    ...mapGetters(['getEmployersDropdown', 'getUserProfile', 'getCurrentPage', 'getTotalPages']),
  },
  mounted() {
    this.isLoading = true;
    this.handleSearchFilters();
    this.isLoading = false;
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.table-controls {
  // min-height: 50vh;
}

.modal-body {
  p {
    margin-bottom: 0;
  }
}

.fa-briefcase {
  font-size: 18px;
}

.icon-wrapper {
  .svg-icon {
    width: 18px;
    height: 18px;
  }

  /*  a {
    fill: #28a745;

    &:hover {
      fill: #1e8035;
    }
  } */

  /* a:not(:first-child) {
    fill: #f02800;

    &:hover {
      fill: #b61e00;
    }
  } */
}

.mobile-only {
  display: none;
}

.desktop-only {
  display: block;
}

.desktop-only-table {
  display: table;
  table-layout: auto;
}

.controls-wrap {
  width: 100%;
  .integration-group {
    width: 39.3%;
  }
}

.card {
  height: 81.7vh;
}

@media only screen and (max-width: 1251px) {
  .card {
    margin: 24px 23px 0 23px !important;
  }
}

@media only screen and (max-width: 992px) {
  .card {
    min-height: 100vh;
    margin: 24px 0px 0 0px !important;
  }
  .mobile-qualification {
    font-family: $font-family-sans-lato;
    display: block;
    .list-unstyled {
      li {
        a {
          text-decoration: none;
        }
        .job-ad-title {
          display: block;
          font-size: 18px;
          font-weight: 700;
          margin-bottom: 4px;
        }
        .company-name {
          color: $color-orange;
          font-size: 15px;
          margin-bottom: 5px;
        }
        .date {
          color: #5f5f5f;
        }
        position: relative;
        border-bottom: 1px solid #ddd;
        padding: 9px 18px 15px 18px;
        .svg-icon {
          width: 22px;
          height: 22px;
          display: inline-block;
        }
        .action-buttons {
          margin-top: 8px;
          .svg-icon {
            width: 22px;
            height: 22px;
            display: inline-block;
          }
          .green {
            fill: #28a745;
          }
          .red {
            fill: #f02800;
            margin-left: 10px;
          }
        }
      }
    }
  }
  .controls-wrap {
    width: 100%;
    .integration-group {
      width: 100%;
    }
  }
  .mobile-only {
    display: block;
  }

  .desktop-only {
    display: none;
  }

  .desktop-only-table {
    display: none;
  }
}

@media only screen and (max-width: 768px) {
  .card {
    min-height: 100vh;
  }
  .mobile-qualification {
    font-family: $font-family-sans-lato;
    display: block;
    .list-unstyled {
      li {
        a {
          text-decoration: none;
        }
        .job-ad-title {
          display: block;
          font-size: 18px;
          font-weight: 700;
          margin-bottom: 4px;
        }
        .company-name {
          color: $color-orange;
          font-size: 15px;
          margin-bottom: 5px;
        }
        .date {
          color: #5f5f5f;
        }
        position: relative;
        border-bottom: 1px solid #ddd;
        padding: 9px 18px 15px 18px;
        .svg-icon {
          width: 22px;
          height: 22px;
          display: inline-block;
        }
        .action-buttons {
          margin-top: 8px;
          .svg-icon {
            width: 22px;
            height: 22px;
            display: inline-block;
          }
          .green {
            fill: #28a745;
          }
          .red {
            fill: #f02800;
            margin-left: 10px;
          }
        }
      }
    }
  }
  .controls-wrap {
    width: 100%;
    .integration-group {
      width: 100%;
    }
  }
  .mobile-only {
    display: block;
  }

  .desktop-only {
    display: none;
  }

  .desktop-only-table {
    display: none;
  }
}

@media only screen and (max-width: 576px) {
  #wrapper {
    .card {
      min-height: 100vh !important;
      margin-top: 0 !important;
    }
  }
  .mobile-qualification {
    font-family: $font-family-sans-lato;
    display: block;
    .list-unstyled {
      li {
        a {
          text-decoration: none;
        }
        .job-ad-title {
          display: block;
          font-size: 18px;
          font-weight: 700;
          margin-bottom: 4px;
        }
        .company-name {
          color: $color-orange;
          font-size: 15px;
          margin-bottom: 5px;
        }
        .date {
          color: #5f5f5f;
        }
        position: relative;
        border-bottom: 1px solid #ddd;
        padding: 9px 18px 15px 18px;
        .svg-icon {
          width: 22px;
          height: 22px;
          display: inline-block;
        }
        .action-buttons {
          margin-top: 8px;
          .svg-icon {
            width: 22px;
            height: 22px;
            display: inline-block;
          }
          .green {
            fill: #28a745;
          }
          .red {
            fill: #f02800;
            margin-left: 10px;
          }
        }
      }
    }
  }
  .controls-wrap {
    width: 100%;
    .integration-group {
      width: 100%;
    }
  }
  .mobile-only {
    display: block;
  }

  .desktop-only {
    display: none;
  }

  .desktop-only-table {
    display: none;
  }
}
</style>
